import { createContext } from 'react';

export type GetVideo = (id: string) => HTMLVideoElement | null;
export type TrackMediaLoad = <T>(promise: Promise<T>) => Promise<T>;

export type MediaContextValue = {
  /** Look up a registered video by id. Returns null if not found. */
  getVideo: GetVideo;

  /** Register an HTMLVideoElement so playback hooks find it and it lives in the DOM. */
  registerVideo: (id: string, element: HTMLVideoElement) => void;
  unregisterVideo: (id: string) => void;

  /** Routes an HTMLAudioElement through the audio graph so it reaches the speakers. */
  registerAudio: (element: HTMLAudioElement) => void;

  /** True while any media (videos on hydration or upload) is still pre-buffering. */
  isMediaLoading: boolean;
  /** Wraps an async media op; counter bumps for its lifetime and clears on settle. */
  trackMediaLoad: TrackMediaLoad;

  /** Resumes the AudioContext if suspended (call on first user gesture). */
  resumeAudio: () => Promise<void>;
};

export const MediaContext = createContext<MediaContextValue | null>(null);
